import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { Button } from "@covertree/ui";
import { useTheme } from "@mui/material";
import { Coverage } from "@graphql/api";

import { CoverageDetails } from "@routing/Residents/components/CoverageDetails/CoverageDetails";

interface ProofOfCoverageDetailsContentProps {
  coverage: Coverage;
  onSubmit: () => void;
}
function ProofOfCoverageDetailsContent({
  coverage,
  onSubmit,
}: ProofOfCoverageDetailsContentProps) {
  const theme = useTheme();

  return (
    <Stack gap={3}>
      <CoverageDetails coverage={coverage}>
        <Typography lineHeight={theme.spacing(4)} mt={3}>
          Confirm the information below to add the proof of coverage.
        </Typography>
      </CoverageDetails>
      <Button size="medium" onClick={onSubmit}>
        Looks Good, Submit
      </Button>
    </Stack>
  );
}

export default ProofOfCoverageDetailsContent;
